import "./boot-leaflet.js";
import "./styles.css";
import "./app.js";
import { installDockLegend } from "./ui/dockLegend.js";
import { installMobileSheet } from "./ui/mobileSheet.js";

installDockLegend();
installMobileSheet();
